<template>
    <div>
        <div class="columns">
            <div class="column is-6">
                <div class="control has-icons-left">
                    <input v-model="search" class="input" type="text" placeholder="Search...">
                    <span class="icon is-small is-left">
                        <i class="fa fa-search"></i>
                    </span>            
                </div>
            </div>
        </div>

        <table class="table is-hoverable is-bordered is-fullwidth">
            <thead>
                <tr>
                    <th v-for='col in columns' class="sortable" @click='sortBy(col.key)'>
                        {{col.name}} 
                        <i class="fa fa-sort-up is-pulled-right" v-if="column == col.key && reverse"></i>
                        <i class="fa fa-sort-down  is-pulled-right" v-if="column == col.key && !reverse"></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items">
                    <td>{{item.id}}</td>
                    <td>{{item.created_at.date.split('.')[0]}}</td>
                    <th>{{item.ip_address}}</th>
                    <th>{{item.browser}}</th>
                    <th>{{item.city}}</th>
                    <th>{{item.country}}</th>
                    <th>{{item.country_code}}</th>
                    <th>{{item.zip_code}}</th>
                </tr>
            </tbody>
        </table>
        <bulma-pagination :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
    </div>
</template>

<script>
import SentenceRepo from '../../repos/SentenceRepo'
import lodash from 'lodash'

export default {
  name: 'sessions-table',
  props: {
	items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: {required: false, default: false}
  },
  components: {},
  data() {
        return {
            search: '',
            column: 'id',
            columns: [
                {
                    name: '#',
                    key: 'id'
                },
                {
                    name: 'Date',
                    key: 'created_at'
                },
                {
                    name: 'Ip',
                    key: 'ip_address'
                },

                {
                    name: 'Browser',
                    key: 'browser'
                },
                {
                    name: 'City',
                    key: 'city'
                },
                {
                    name: 'Country',
                    key: 'country'
                },
                {
                    name: 'Country Code',
                    key: 'country_code'
                },
                {
                    name: 'Zip',
                    key: 'zip_code'
                },
            ],
            reverse: true,
        }
  },
  created(){        
  },
  methods: {
    sortBy(column) {    
    
        if(column != ''){
            if(this.column == column){
              this.reverse = !this.reverse;
            }
            else{
              this.column = column;
            }

            let direction = this.reverse ? "asc" : "desc";

            this.$emit("sort", this.column + "," + direction);
        }
    },   
    onPageChanged(page){
        this.$emit("pageChanged", page);
    },
  },
  watch: {
      'search': _.debounce(function(value){
        this.$emit("search", value);
      }, 800) 
  },
  computed: {
  }  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sessions/Table.vue